import { render, staticRenderFns } from "./AppHeader_bkp.vue?vue&type=template&id=2fac1676&"
import script from "./AppHeader_bkp.vue?vue&type=script&lang=js&"
export * from "./AppHeader_bkp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports